import useIsMobile from "hooks/useIsMobile.ts";
import { memo } from "react";
import Separator from "../components/Separator.tsx";
import "./data-entry.css";

interface FiltroDataProps {
	title?: string;
	value: string;
	onChange: (value: string) => void;
	titleFrente?: boolean;
	disabled?: boolean;
}

function FiltroData({
	title = "Início",
	value,
	onChange,
	titleFrente = true,
	disabled = false,
}: FiltroDataProps) {
	const isMobile = useIsMobile(450);
	return (
		<div className="filtro-data-container">
			<div className="filtro-data-box">
				{(titleFrente || isMobile) && (
					<div>
						<p>{title}</p>
					</div>
				)}
				{(titleFrente || isMobile) && (
					<Separator
						size="xs"
						direction={isMobile ? "vertical" : "horizontal"}
					/>
				)}
				<input
					type="date"
					className="filtro-data-input"
					value={value}
					disabled={disabled}
					onChange={(e) => {
						const value = e.target.value;
						const newDate = value === "" ? new Date() : new Date(value);

						let dia = "";

						if (titleFrente) {
							dia = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, "0")}-01`;
						} else {
							const ultimoDia = new Date(
								newDate.getFullYear(),
								newDate.getMonth() + 1,
								0,
							).getDate();
							dia = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, "0")}-${String(ultimoDia).padStart(2, "0")}`;
						}

						onChange(value === "" ? dia : value);
					}}
				/>
				{!titleFrente && !isMobile && (
					<Separator size="xs" direction="horizontal" />
				)}
				{!titleFrente && !isMobile && (
					<div>
						<p>{title}</p>
					</div>
				)}
			</div>
		</div>
	);
}

export default memo(FiltroData);
